const NAVBAR_HEIGHT = 55;

export default NAVBAR_HEIGHT;
